export default () =>
  (items, otherTeamId) =>
    items.filter(item => item.id !== otherTeamId);



// WEBPACK FOOTER //
// ./modules/filters/prevent-same-match-teams.js